import React, { useState, useEffect } from 'react';
import { Cookie, X, Check, Shield } from 'lucide-react';
import './CookieConsent.css';

const CookieConsent = ({ onViewPolicy }) => {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    setAnimateOut(true);
    setTimeout(() => {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setVisible(false);
    }, 300);
  };

  const handleReject = () => {
    setAnimateOut(true);
    setTimeout(() => {
      localStorage.setItem('cookieConsent', 'rejected');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setVisible(false);
    }, 300);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-banner ${animateOut ? 'cookie-banner-out' : ''}`}>
      <div className="cookie-content">
        <div className="cookie-icon-wrapper">
          <Cookie size={24} />
        </div>
        <div className="cookie-text">
          <h4>Cookie Notice</h4>
          <p>
            We use cookies to enhance your experience. By continuing to use this site, you agree to our use of cookies for storing your preferences and progress.{' '}
            <button className="cookie-policy-link" onClick={onViewPolicy}>
              Learn more
            </button>
          </p>
        </div>
      </div>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-reject" onClick={handleReject}>
          <X size={16} />
          Reject
        </button>
        <button className="cookie-btn cookie-accept" onClick={handleAccept}>
          <Check size={16} />
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
